import React from 'react';
import { ListView } from 'antd-mobile';
import { Spin } from 'antd';
import { Header } from '../../../component';
import wandu from '../../../service/wandu';
import styles from './index.css';
import avatar_default_pic from '../../../asset/avatar_default.png';
import two_guy_pic from '../../../asset/two_guy.png';

const Tweet = ({
    headimgurl,
    user_name,
    content,
    time_str,
    reply_num,
    zan_num}) => (
<div style={{
    position: 'relative',
    padding: '20px 0',
    borderBottom: '1px solid #f3f4f5',
}}>
    <div style={{
        position: 'absolute',
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundImage: `url(${headimgurl ? headimgurl : avatar_default_pic})`,
	    backgroundSize: 'cover',
        backgroundPosition: 'center',
    }}/>
    <div style={{
        marginLeft: '46px',
    }}>
        <div style={{
            marginTop: '6px',
            color: '#999999',
            fontSize: '16px',
            lineHeight: '22px',
            height: '22px',
        }}>{user_name}</div>
        <div style={{
            marginTop: '10px',
            color: '#333333',
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.3px',
        }}>{content}</div>
        <div style={{
            marginTop: '10px',
            color: '#999999',
            fontSize: '14px',
            lineHeight: '20px',
        }}>
            <span style={{marginRight: '20px'}}>{time_str}</span>
            <span style={{marginRight: '20px'}}>回复{reply_num}</span>
            <span>点赞{zan_num}</span>
        </div>
    </div>
</div>
)

export default class Comment extends React.Component {

    constructor(args) {
        super(args);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => false,
        });
        this.data = [];
        this.state = {
            dataSource: dataSource.cloneWithRows(this.data),
            loading: false,
            load_all: false, 
        };
    }

    componentDidMount() {
        this._load_more(this.props.novel_id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.novel_id !== this.props.novel_id) {
            this.data = []; 
            this._load_more(this.props.novel_id);
        }
    }

    _load_more(novel_id) {
        if (this.state.loading) {
            return false;
        }
        this.setState({
            loading: true,
        }, () => {
            let para = { novel_id };
            if (this.data.length > 0) {
                para.last_reply_time = this.data[this.data.length - 1].last_reply_time;
            }
            wandu.book_comment(para).then(res => {
                if (res.length === 0) {
                    this.setState({
                        load_all: true,
                        loading: false,
                    });
                } else {
                    this.data = this.data.concat(res);
                    this.setState({
                        dataSource: this.state.dataSource.cloneWithRows(this.data),
                        loading: false,
                    });
                }
            }).catch(e => {
                this.setState({ loading: false });
                console.log(e);
            });
        });
    }

    onEndReached = (event) => {
        if (this.state.loading || this.state.load_all) {
            return;
        }
        this._load_more(this.props.novel_id);
    }

    render() {
        const row = (rowData, sectionID, rowID) => {
            return <Tweet key={rowID} {...rowData} />
        };
        return (
        <div>
            <Header title="热门评论" em />
        {this.data.length === 0
            ? 
            (<div className={styles.no_comments}>
                <img alt='' src={two_guy_pic} />
                <div>暂无评论</div> 
            </div>)
            :
            (<ListView
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}
                renderFooter={() => {
                    if (this.state.loading) {
                        return <div style={{ padding: 30, textAlign: 'center' }}><Spin /></div>;
                    }
                    if (this.state.load_all) {
                        return null;
                    } 
                    return null;
                }}
                renderRow={row}
                pageSize={10}
                useBodyScroll
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
            />)
        }
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/detail/comment.js